export function discriminate<K extends PropertyKey, V extends string | number | boolean>(
  discriminantKey: K,
  ...discriminantValues: V[]
) {
  // oxlint-disable-next-line typescript/no-explicit-any
  return <T extends Record<K, any>>(
    obj: T & Record<K, V extends T[K] ? T[K] : V>,
  ): obj is Extract<T, Record<K, V>> =>
    discriminantValues.find((i) => obj[discriminantKey] === i) !== undefined;
}

export function isNumber(x: unknown): x is number {
  return typeof x === "number" && !isNaN(x);
}

export function omit<T extends Record<string, unknown>, K extends keyof T>(
  obj: T,
  key: K,
): Omit<T, K> {
  const { [key]: _, ...rest } = obj;
  return rest;
}

/**
 * Tests if the given object is empty. An object is considered empty if it has no own properties.
 * @param obj
 * @returns
 */
export function isEmptyObject(obj: Record<string, unknown>) {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
}
